import React from 'react';
import { Outlet } from 'react-router-dom';
import Logo from '@scramble/design-system/logo/scramble_logo_black.svg';
import { LanguageSwitcher } from '@scramble/ui';
import { PublicLayoutProps } from './types';
import s from './index.module.scss';

export const PublicLayout = ({ footer, currentLocale, onLocaleChange, children }: PublicLayoutProps) => {
  return (
    <div className={s.wrapper}>
      <header className={s.header}>
        <div className="g-container">
          <div className={s.logo}>
            <img src={Logo} alt="logo" width={112} height={20} />
          </div>
          <div className={s.controls}>
            <LanguageSwitcher currentLocale={currentLocale} onLocaleChange={onLocaleChange} />
          </div>
        </div>
      </header>
      <main className={s.main}>{children || <Outlet />}</main>
      {footer}
    </div>
  );
};